import { render, staticRenderFns } from "./ReservedCharsModal.vue?vue&type=template&id=8d05a520&scoped=true&"
import script from "./ReservedCharsModal.vue?vue&type=script&lang=ts&"
export * from "./ReservedCharsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d05a520",
  null
  
)

export default component.exports